/**
 * This file is created to contain all redux dependencies.
 * redux, react-redux, redux-saga
 */
/* eslint-disable */
export const Redux = require('redux');
export const ReactRedux = require('react-redux');
export const ReduxSaga = require('redux-saga');
/* eslint-enable */
